module.exports = __webpack_public_path__ + "static/media/NexaBold.3935bb7b.woff";